<template>
  <svg
id="Capa_1" fill="white" height="20" width="20" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300 300" xml:space="preserve" data-darkreader-inline-fill="">
    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <path
        d="M294,48c0-8.284-6.716-15-15-15H15C6.716,33,0,39.716,0,48v198c0,8.284,6.716,15,15,15h264c8.284,0,15-6.716,15-15V48z M124,113.134c0-2.68,1.596-5.155,3.917-6.495c2.32-1.34,5.263-1.34,7.583,0l37.046,21.364c2.32,1.34,3.771,3.815,3.771,6.495 s-1.419,5.155-3.74,6.495l-36.999,21.364c-1.16,0.67-2.452,1.005-3.747,1.005s-2.755-0.335-3.915-1.005 c-2.32-1.34-3.915-3.815-3.915-6.495V113.134z M263.333,232H89v1c0,4.143-3.357,7.5-7.5,7.5S74,237.143,74,233v-1H30.333 c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h44c0-4.143,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5h174c4.143,0,7.5,3.357,7.5,7.5 S267.476,232,263.333,232z">
    </path>
  </g>
</svg></template>
<script>
export default {};
</script>